export default {
  tabs: {
    accounts: "Comptes",
    report_config: "Configuration des rapports",
    general: "Général",
    billing_notifications: "Facturation et notifications",
    privacy: "Confidentialité",
    help: "Aide",
    about: "À propos",
  },
  general: {
    title: "Paramètres généraux",
    displaySettings: "Paramètres d'affichage",
    theme: "Thème",
    primaryColor: "Couleur principale",
    languageSettings: "Paramètres de langue",
    language: "Langue",
    otherSettings: "Autres paramètres",
    timezone: "Fuseau horaire",
    selectTimezone: "Sélectionner le fuseau horaire",
    dateFormat: "Format de date",
    selectDateFormat: "Sélectionner le format de date",
    numberFormat: "Format numérique",
    selectNumberFormat: "Sélectionner le format numérique",
    englishFormat: "Format anglais",
    europeanFormat: "Format européen",
    spaceFormat: "Format avec espaces",
  },
  account: {
    title: "Paramètres du compte",
    subtitle:
      "Gérez vos informations personnelles, vos paramètres de sécurité et vos préférences de compte",
    edit: "Modifier",
    save: "Enregistrer les modifications",
    cancel: "Annuler",
    profile: {
      title: "Informations personnelles",
      name: "Nom",
      email: "Adresse email",
      email_tip: "L'adresse email ne peut pas être modifiée",
      company: "Entreprise",
      phone: "Téléphone",
      phone_invalid: "Le format du numéro de téléphone est invalide",
      bio: "Biographie",
      website: "Site web",
      website_invalid: "Le format de l'URL du site web est invalide",
      location: "Emplacement",
      position: "Poste",
      validation_error: "Échec de la validation du formulaire, veuillez vérifier vos saisies",
      change_avatar: "Changer d'avatar",
      remove: "Supprimer l'avatar",
      save_success: "Profil mis à jour avec succès",
      avatar_format_error: "Vous ne pouvez télécharger que des fichiers JPG/PNG !",
      avatar_size_error: "L'image doit être inférieure à 2 Mo !",
      avatar_upload_error: "Échec du téléchargement de l'avatar",
      avatar_format_tip: "Format JPG/PNG",
      avatar_size_tip: "Taille maximale du fichier : 2 Mo",
      name_placeholder: "Saisissez votre nom",
      company_placeholder: "Saisissez votre entreprise",
      phone_placeholder: "Saisissez votre numéro de téléphone",
      bio_placeholder: "Parlez-nous de vous",
      website_placeholder: "https://exemple.com",
      location_placeholder: "Saisissez votre emplacement",
      position_placeholder: "Saisissez votre poste",
    },
    security: {
      password_title: "Paramètres du mot de passe",
      password_tip:
        "Pour la sécurité de votre compte, il est recommandé de changer régulièrement votre mot de passe",
      change_password: "Changer le mot de passe",
      current_password: "Mot de passe actuel",
      new_password: "Nouveau mot de passe",
      confirm_password: "Confirmer le nouveau mot de passe",
      save_password: "Enregistrer le mot de passe",
      password_changed: "Mot de passe mis à jour",
      password_mismatch: "Le nouveau mot de passe et la confirmation ne correspondent pas",
      password_incorrect: "Le mot de passe actuel est incorrect",
      password_required: "Veuillez remplir tous les champs de mot de passe",
      password_too_short: "Le mot de passe doit comporter au moins 8 caractères",
      password_change_failed: "Échec du changement de mot de passe",
      two_factor_auth_title: "Authentification à deux facteurs",
      two_factor_auth: "Authentification à deux facteurs",
      two_factor_auth_desc:
        "Ajoutez une couche de sécurité supplémentaire qui nécessite à la fois votre mot de passe et un code de vérification de l'appareil pour vous connecter",
      two_factor_auth_coming_soon: "Fonctionnalité à venir",
      // Ajout des textes d'espace réservé
      current_password_placeholder: "Saisissez le mot de passe actuel",
      new_password_placeholder: "Saisissez le nouveau mot de passe",
      confirm_password_placeholder: "Confirmez le nouveau mot de passe",
    },
    login_activity: {
      title: "Activité de connexion",
      manage: "Gérer",
      trust_device: "Faire confiance à l'appareil",
      logout_device: "Déconnecter l'appareil",
      device_trusted: "L'appareil {location} a été approuvé",
      device_logged_out: "Déconnecté de l'appareil {location}",
      showing_details: "Affichage des détails pour {location} - IP : {ip}, Heure : {time}",
      manage_info: "Gestion de l'activité de connexion pour {location}",
      login_details: "Détails de connexion",
      ip_address: "Adresse IP",
      time: "Heure",
      isp: "Fournisseur d'accès Internet",
      bot_score: "Score de bot",
      locations: {
        current: "Appareil actuel",
      },
      suspicious: "Suspect",
      mobile_device: "Appareil mobile",
      api_client: "Client API",
      trusted: "Approuvé",
      device: "Appareil",
      client: "Client",
      unknown: "Inconnu",
      risk_reasons: "Raisons de risque",
      location: "Emplacement",
      trust_failed: "Échec de l'approbation de l'appareil",
      show_more: "Afficher {0} de plus",
      show_less: "Afficher moins",
    },
    danger: {
      title: "Zone dangereuse",
      delete_title: "Supprimer le compte",
      delete_desc:
        "Supprimez définitivement votre compte et toutes les données associées. Cette action ne peut pas être annulée.",
      confirm_title: "Êtes-vous sûr de vouloir supprimer votre compte ?",
      confirm_desc:
        "Cette action supprimera définitivement votre compte et toutes les données associées. Elle ne peut pas être annulée.",
      confirm_email_tip: "Pour confirmer la suppression, veuillez saisir votre adresse email :",
      confirm_email_placeholder: "Saisissez votre adresse email",
      confirm: "Confirmer la suppression",
      cancel: "Annuler",
      delete_account: "Supprimer le compte",
      delete_success: "Compte supprimé avec succès",
      email_mismatch: "L'adresse email ne correspond pas. Veuillez saisir la bonne adresse email.",
    },
  },
  privacy: {
    title: "Paramètres de confidentialité",
    privacyPolicyAgreement: "Accord sur la politique de confidentialité",
    privacyPolicyAgreementDesc:
      "Vous avez accepté notre Politique de confidentialité lors de l'inscription à un compte",
    privacyPolicyAgreementInfo:
      "L'accord sur la politique de confidentialité ne peut pas être révoqué",
  },
  reportConfig: {
    colorPicker: {
      title: "Sélecteur de couleur",
    },
    currencyName: {
      EUR: "Euro (€)",
      USD: "Dollar américain ($)",
      GBP: "Livre sterling (£)",
    },
    fetchDataFailed: "Échec de la récupération des données",
    configSelection: "Sélection de configuration",
    default: "Par défaut",
    professional: "Professionnel",
    simple: "Simple",
    custom: "Personnalisé",
    exportType: "Type d'exportation",
    upgradeToUnlock: "Passez à la version supérieure pour débloquer cette fonctionnalité",
    commonSettings: "Paramètres communs",
    tableHeaderFont: "Police de l'en-tête du tableau",
    tableCellFont: "Police des cellules du tableau",
    textFont: "Police du texte",
    textColor: "Couleur du texte",
    tableHeaderBg: "Arrière-plan de l'en-tête du tableau",
    selectColor: "Sélectionner une couleur",
    dataFormat: "Format des données",
    selectFormat: "Sélectionner le format",
    titleFontSize: "Taille de la police du titre",
    watermarkFontSize: "Taille de la police du filigrane",
    titleColor: "Couleur du titre",
    premiumTitleColorActive: "La couleur de titre premium est active",
    blue: "Bleu",
    red: "Rouge",
    displayFields: "Champs à afficher",
    showDate: "Afficher la date",
    showContact: "Afficher le contact",
    showEmail: "Afficher l'email",
    showTitle: "Afficher le titre",
    showEmissionDetails: "Afficher les détails des émissions",
    showSummary: "Afficher le résumé",
    showTotalDistance: "Afficher la distance totale",
    showProductionEmission: "Afficher l'émission de production",
    showTransportEmission: "Afficher l'émission de transport",
    showTotalEmission: "Afficher l'émission totale",
    showTax: "Afficher la taxe",
    showCompliance: "Afficher la déclaration de conformité",
    privacyFields: "Champs de confidentialité",
    hideCompanyName: "Masquer le nom de l'entreprise",
    hideContact: "Masquer le contact",
    hideEmail: "Masquer l'email",
    hideLogo: "Masquer le logo de l'entreprise",
    hideWeight: "Masquer le poids",
    premiumFeatures: "Fonctionnalités premium",
    generalConfig: "Configuration générale",
    language: "Langue",
    selectLanguage: "Sélectionner la langue",
    currency: "Devise",
    selectCurrency: "Sélectionner l'unité de devise",
    showLogo: "Afficher le logo",
    companyLogo: "Logo de l'entreprise",
    logoSupportFormat: "Formats pris en charge : JPG, PNG, GIF, WEBP, Max 2 Mo",
    showCompany: "Afficher l'entreprise",
    companyName: "Nom de l'entreprise",
    enterCompanyName: "Saisir le nom de l'entreprise",
    customContact: "Contact personnalisé",
    enterContact: "Saisir le contact",
    customEmail: "Email personnalisé",
    enterEmail: "Saisir l'email",
    customCompliance: "Déclaration de conformité personnalisée",
    enterCompliance: "Saisir la déclaration de conformité",
    customFooter: "Pied de page personnalisé",
    excelFontStyle: "Le style de police dans Excel est contrôlé par les paramètres par défaut",
    footerPlaceholder: "ex. Rapport de conformité CBAM TaxEcoBit",
    showEmissionChart: "Afficher le graphique des émissions",
    pdfAdvancedFeatures: "Fonctionnalités avancées PDF",
    removeWatermark: "Supprimer le filigrane",
    showSignatureArea: "Afficher la zone de signature",
    removeQRCode: "Supprimer le code QR",
    logoPosition: "Position du logo",
    selectPosition: "Sélectionner la position",
    topLeft: "En haut à gauche",
    topRight: "En haut à droite",
    borderStyle: "Style de bordure",
    none: "Aucun",
    solid: "Solide",
    premiumTitleColor: "Couleur de titre premium",
    customTableHeaderBg: "Arrière-plan d'en-tête de tableau personnalisé",
    customWatermark: "Filigrane personnalisé",
    enterWatermark: "Saisir le contenu du filigrane",
    inviteText: "Texte d'invitation",
    enterInviteText: "Saisir le texte d'invitation",
    excelAdvancedFeatures: "Fonctionnalités avancées Excel",
    columnWidth: "Largeur de colonne",
    cellBackground: "Arrière-plan de cellule",
    mergeHeader: "Fusionner l'en-tête",
    enableFilter: "Activer le filtre",
    addDigitalSignature: "Ajouter une signature numérique",
    signatureContent: "Contenu de la signature",
    enterSignature: "Saisir le contenu de la signature",
    premiumFeaturesDesc:
      "Ces fonctionnalités premium peuvent améliorer le professionnalisme de vos rapports",
    upgradeMessage:
      "Passez à la version premium pour débloquer le changement de langue, le logo personnalisé et d'autres fonctionnalités exclusives",
    lightGray: "Gris clair",
    darkGray: "Gris foncé",
    messages: {
      excelExportRequiresPro: "L'exportation Excel nécessite un abonnement Pro, basculé en PDF",
      logoUploadFailed: "Échec du téléchargement du logo",
      configSaveSuccess: "Configuration enregistrée avec succès",
      configSaveFailed: "Échec de l'enregistrement de la configuration",
      imageFileOnly: "Seuls les fichiers image sont pris en charge !",
      imageSizeLimit: "La taille de l'image ne doit pas dépasser 2 Mo !",
      fileReadFailed: "Échec de la lecture du fichier",
    },
  },
  billing: {
    title: "Facturation et notifications",
    compliance: "Conformité requise",
    compliance_desc: "Notifications critiques, ne peuvent pas être désactivées",
    service: "Service critique",
    service_desc: "Recommandé de garder activé",
    experience: "Expérience utilisateur",
    experience_desc: "Optionnel, peut être désactivé",
  },
  notification: {
    title: "Paramètres de notification",
    policy: "Mises à jour de la politique CBAM",
    policy_desc:
      "Recevez les changements urgents de réglementation CBAM de l'UE. Requis pour la conformité et l'évitement des pénalités.",
    payment: "Alertes d'échec de paiement",
    payment_desc:
      "Soyez informé immédiatement si le paiement échoue pour éviter l'interruption du service.",
    expiry: "Rappels d'expiration du plan",
    expiry_desc:
      "Soyez informé 3 jours avant l'expiration de votre plan. Renouvelez à temps pour éviter la pause du service.",
    quota: "Avertissements de quota",
    quota_desc:
      "Alerte lorsque vous utilisez 80 % des calculs mensuels. Évitez les limites inattendues.",
    ticket: "Mises à jour des tickets de support",
    ticket_desc:
      "Recevez des mises à jour par email lorsque le statut de votre ticket de support change.",
    referral: "Récompenses de parrainage",
    referral_desc:
      "Soyez informé lorsque vous gagnez des calculs gratuits grâce à des parrainages réussis.",
  },
  info: {
    about_taxecobit: "À propos de TaxEcoBit",
    about_taxecobit_description:
      "TaxEcoBit est un outil spécialisé conçu pour les PME de l'UE afin de rationaliser les rapports et la conformité aux émissions de carbone CBAM. Avec une précision supérieure à 90 %, il permet des calculs et une génération de rapports rapides, aidant à atténuer les risques de pénalités (1 000 € à 10 000 €).",
    our_vision: "Notre vision",
    our_vision_description:
      "Nous visons à autonomiser les PME de l'UE avec une conformité CBAM transparente, favorisant la croissance durable et soutenant les objectifs de durabilité de 2026 grâce à des solutions innovantes.",
    contact_us: "Nous contacter",
    follow_us: "Suivez-nous :",
    version_info: "Informations sur la version",
    version: "Version",
    last_updated: "Dernière mise à jour",
    license: "Licence",
    copyright: "© 2025 TaxEcoBit. Tous droits réservés.",
  },
};
